'use strict';

var $             = require('jquery');
var Core          = require('../core/core.js');
var FormTextInput = require('./form__textinput.js');
var FormTextArea  = require('./form__textarea.js');
var FormButton    = require('./form__button.js');
var FormFile      = require('./form__file.js');
var FormSelectBox = require('./form__selectbox.js');

/**
 * Creates a FormAbstractElement
 *
 * @class
 */

class FormAbstractElement extends Core {

    _defaults() {
        return {
            target: '.js-formtextinput',
            fields: {
                'label': ""
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class='editor__form__element'>
                <div class='editor__form__element__label js-editor__form__element__label'><%- label %></div>
                <div class='editor__form__element__container js-editor__form__element__container'></div>
            </div>
        `;

        super.render();
    }

    /**
     * adds a link below section
     *
     * @param {String} label
     * @param {String} linkTitle
     * @param {String} linkUrl
     */
    addLinkBelow(label, linkTitle, linkUrl){
        var mi = $("<div class='editor__form__element__moreinfo'></div>").appendTo(this.$el);
        mi.append(label);
        if(linkTitle && linkUrl){
            mi.append("<a href='"+linkUrl+"' target='_blank'>"+linkTitle+"</a>");
        }
    }

    /**
     * adds a link below section
     *
     * @param {String} text
     */
    addSubhead(text){
        var sh = $("<div class='editor__form__element__subhead'></div>").insertAfter($('.js-editor__form__element__label', this.$el));
        sh.append(text);
    }

    /**
     * add a single text input
     *
     * @param {String} value
     * @param {String} placeholder
     * @param {Boolean} isReadOnly
     */
    addTextInput(value, placeholder, isReadOnly){
        if(isReadOnly) placeholder = "";
        return new FormTextInput({
            target: $('.js-editor__form__element__container', this.$el),
            fields: {
                'placeholder': placeholder,
                'value': value,
                'isReadOnly': isReadOnly
            }
        });
    }

    /**
     * add a text field
     *
     * @param {String} value
     * @param {String} placeholder
     * @param {Boolean} isReadOnly
     */
    addTextArea(value, placeholder, isReadOnly){
        if(isReadOnly) placeholder = "";
        return new FormTextArea({
            target: $('.js-editor__form__element__container', this.$el),
            fields: {
                'placeholder': placeholder,
                'value': value,
                'isReadOnly': isReadOnly
            }
        });
    }

    /**
     * add a button
     *
     * @param {String} title
     */
    addButton(title){
        return new FormButton({
            target: $('.js-editor__form__element__container', this.$el),
            fields: {
                'title': title
            }
        });
    }

    /**
     * add a file button
     *
     * @param {String} title
     */
    addFileButton(title){
        return new FormFile({
            target: $('.js-editor__form__element__container', this.$el),
            fields: {
                'title': title
            }
        });
    }

    /**
     * add a selectbox
     *
     * @param {String} options
     * @param {String} placeholder
     */
    addSelectBox(value, options, isReadOnly){
        return new FormSelectBox({
            target: $('.js-editor__form__element__container', this.$el),
            fields: {
                'options': options,
                'value': value,
                'read_only': isReadOnly
            }
        });
    }

}

module.exports = FormAbstractElement;
